import { Route } from "react-router-dom";
import AppSections from "../utils/AppSections";
import ProtectedRoute from "./ProtectedRoute";
import Material from "../ui/materials/Material";
import MaterialsList from "../ui/materials/MaterialsList";

const MaterialRoutes = (
  <Route
    path={AppSections.MATERIALS}
    element={
      <ProtectedRoute>
        <Material />
      </ProtectedRoute>
    }
  >
    <Route path="/materials/" element={<MaterialsList />} />
  </Route>
);

export default MaterialRoutes;